// @flow
import {type IntlShape} from 'react-intl';
import type {State as AbacusState} from '../../../reducers/abacus';
import {type Breakpoint, media} from '../../../utils/breakpoints';
import {
    HA_PTA_DATES_AND_NUMBEROFNIGHTSSUMMARY,
    HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
    VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM,
    VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK,
    VRBO_LANDING_SEARCHFORM_DATE_FORMAT
} from '../../../abacus/experiments';

type System = {
    fullLocale: string,
    hostname: string,
    siteName: string
};

type SearchValues = {
    q: string,
    filter: string[],
    arrival: string,
    departure: string,
    adultsCount: number,
    childrenCount: number,
    petIncluded: boolean,
    pinnedPropertyListing: string | null,
    filterSelected: boolean
};

function getOptions(system: System) {
    const {fullLocale, hostname, siteName} = system;

    const systemOptions = {
        site: siteName,
        baseUrl: hostname,
        pageType: 'serp',
        locale: fullLocale
    };

    const formOptions = {
        autoProgress: 'standard',
        autoSubmit: false,
        layout: 'standard',
        align: 'left',
        showSubmitDetailsButtonField: false
    };

    const destinationOptions = {
        autoProgress: 'smart'
    };

    let datesOptions = {
        allowErrorHighlighting: false,
        autoProgress: 'none',
        dateFormatOptions: {
            day: '2-digit',
            month: '2-digit',
            year: '2-digit'
        }
    };

    const guestsOptions = {
        actionLocation: 'search',
        adultsMin: 1
    };

    return {
        systemOptions,
        formOptions,
        destinationOptions,
        datesOptions,
        guestsOptions
    };
}

function getSettings(breakpoint: Breakpoint) {
    const mediaSettings = {
        isMobile: !media(breakpoint, {minWidth: 'SM_MIN'})
    };

    return {
        mediaSettings
    };
}

function getStores(abacus: AbacusState) {
    const abacusStore = {
        experimentData: abacus,
        experimentNames: [
            HA_PTA_DATES_AND_NUMBEROFNIGHTSSUMMARY,
            HA_PTA_SEARCHBOX_HINTTEXTCHOOSINGDATES,
            VRBO_LANDING_ARIA_ROLES_ON_SEARCHFORM,
            VRBO_LANDING_SEARCHFORM_DATEPICKER_DAY_OF_WEEK,
            VRBO_LANDING_SEARCHFORM_DATE_FORMAT
        ]
    };

    return {
        abacusStore
    };
}

function getTranslations(values: SearchValues, intl: IntlShape) {
    const {formatMessage} = intl;

    const selectDateHintMessage = formatMessage({
        id: 'selectTooltipMessage',
        defaultMessage: 'Choose check-out date'
    });

    const translations = {
        selectDateHintMessage
    };

    return {translations};
}

export {getOptions, getSettings, getStores, getTranslations};
